import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { fuseConfig, tokens } from '../../constants';
export var getFuseStyles = () => {
  var spacing = tokens.spacing,
    borderRadius = tokens.borderRadius;
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    },
    step: {
      flex: 1,
      height: 4,
      marginHorizontal: spacing.SPACING_8,
      position: 'relative',
      borderRadius: borderRadius.BORDER_RADIUS_2,
      overflow: 'hidden'
    },
    stepBackground: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: borderRadius.BORDER_RADIUS_2
    },
    stepFill: {
      position: 'absolute',
      height: '100%',
      borderRadius: borderRadius.BORDER_RADIUS_2,
      width: '0%'
    }
  });
};
export var getFuseProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(fuseConfig === null || fuseConfig === void 0 ? void 0 : fuseConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.fuse) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};